import React from 'react';

import styles from './pageHeader.module.scss';

const DEFAULT_LOGO_SRC = '/brand/paction-logo-white-no-text.png';
const DEFAULT_LOGO_ALT = 'Paction';
const DEFAULT_TITLE_ICON_SRC = '/icons/paw-prints-icon.svg';
const DEFAULT_TITLE_ICON_ALT = 'paw prints';

export type PageHeaderProps = {
  title: string;
  logoSrc?: string;
  logoAlt?: string;
  titleIconSrc?: string;
  titleIconAlt?: string;
  hideLogo?: boolean;
  hideIcon?: boolean;
  hideTitle?: boolean;
  titleLevel?: 1 | 2 | 3 | 4 | 5 | 6;
  useHeadingTag?: boolean;
  className?: string;
  wrapperClassName?: string;
};

const renderTitleWithTrademarks = (titleText: string) => {
  const parts = titleText.split('®');

  return parts.map((part, index) => (
    <React.Fragment key={`${part}-${index}`}>
      {part}
      {index < parts.length - 1 ? (
        <>
          <span className={styles.trademark}>®</span>
          {'\u00A0'}
        </>
      ) : null}
    </React.Fragment>
  ));
};

export function PageHeader({
  title,
  logoSrc,
  logoAlt,
  titleIconSrc,
  titleIconAlt,
  hideLogo,
  hideIcon,
  hideTitle,
  titleLevel = 1,
  useHeadingTag = true,
  className,
  wrapperClassName
}: PageHeaderProps) {
  const TitleTag: React.ElementType = useHeadingTag
    ? (`h${titleLevel}` as React.ElementType)
    : 'div';

  const resolvedLogoSrc = hideLogo ? undefined : (logoSrc ?? DEFAULT_LOGO_SRC);
  const resolvedLogoAlt = logoAlt ?? DEFAULT_LOGO_ALT;

  const resolvedTitleIconSrc = hideIcon
    ? undefined
    : (titleIconSrc ?? DEFAULT_TITLE_ICON_SRC);
  const resolvedTitleIconAlt = titleIconAlt ?? DEFAULT_TITLE_ICON_ALT;

  return (
    <div
      className={[styles.wrapper, wrapperClassName].filter(Boolean).join(' ')}
    >
      <div className={[styles.pageHeader, className].filter(Boolean).join(' ')}>
        {resolvedLogoSrc ? (
          <img
            className={styles.logo}
            alt={resolvedLogoAlt}
            src={resolvedLogoSrc}
          />
        ) : null}
        {!hideTitle ? (
          <TitleTag className={styles.title}>
            {renderTitleWithTrademarks(title)}
            {resolvedTitleIconSrc ? (
              <img
                src={resolvedTitleIconSrc}
                alt={resolvedTitleIconAlt}
                className={styles.titleIcon}
              />
            ) : null}
          </TitleTag>
        ) : null}
      </div>
    </div>
  );
}
